var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 38,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3946 52H37.3934C36.6946 52 36.0338 51.6881 35.5967 51.1517L21.5083 33.8941C20.7103 32.9176 20.8694 31.4898 21.8623 30.705C22.8552 29.9202 24.3071 30.0767 25.1051 31.0532L37.398 46.1118L49.8974 30.8456C50.6965 29.8703 52.1484 29.7161 53.1401 30.5009C54.1319 31.2868 54.2887 32.7146 53.4907 33.69L39.1924 51.154C38.7542 51.6881 38.0945 52 37.3957 52H37.3946Z",
    fill: "#515151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.acb5c689d3d768ad17dbb2eed8366ffa.svg";
export { ForwardRef as ReactComponent };